import { render, staticRenderFns } from "./StreamDetail.vue?vue&type=template&id=b6610706&scoped=true&"
import script from "./StreamDetail.vue?vue&type=script&lang=js&"
export * from "./StreamDetail.vue?vue&type=script&lang=js&"
import style0 from "./StreamDetail.vue?vue&type=style&index=0&id=b6610706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6610706",
  null
  
)

export default component.exports